module.exports = __webpack_public_path__ + "images/7dbfa4c940be52979d01494d28f402ef.svg";